export const shouldShowCategories = (catsStore) => {
  return computed(() => {
    return (catsStore.page.number + 1) * catsStore.page.size < catsStore.totalCategories
  })
}
